import { Helmet } from 'react-helmet-async';

export default function OpenGraphGeneral() {
  return (
    <Helmet>
      <meta
        property='og:title'
        content='Juridiikan ajankohtaiset - Alma Insights'
      />
      <meta property='og:type' content='website' />
      <meta
        property='og:url'
        content='https://www.juridiikka.almainsights.fi/'
      />
      <meta
        property='og:image'
        content='https://www.juridiikka.almainsights.fi/og-image.jpg'
      />
      <meta
        property='og:description'
        content='Jatkuvasti täydentyvä sisältöpalvelu juridiikan asiantuntijoille.'
      />
      <meta property='og:site_name' content='Juridiikan ajankohtaiset' />
      <meta property='og:locale' content='fi_FI' />
    </Helmet>
  );
}
